import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "volume", "before", "after", "savings", "platform", "platformLabel", "breakdown"]

  // Real fee structures from competitive research (Feb 2026)
  static fees = {
    tcgplayer: {
      label: "TCGPlayer",
      commission: 0.1075,     // 10.75% marketplace fee
      processing: 0.025,      // 2.5% payment processing
      perTxn: 0.30,           // $0.30 per transaction
      monthly: 0,
      description: "10.75% + 2.5% processing + $0.30/txn"
    },
    ebay: {
      label: "eBay",
      commission: 0.1325,     // 13.25% final value fee
      processing: 0,          // included in FVF
      perTxn: 0.30,           // $0.30 per transaction
      monthly: 0,
      description: "13.25% FVF + $0.30/txn (before promoted listings)"
    },
    shopify: {
      label: "Shopify + Apps",
      commission: 0,
      processing: 0.029,      // 2.9% Stripe
      perTxn: 0.30,
      monthly: 128,           // $39 Shopify Basic + ~$89 card apps (Mascot etc.)
      description: "$39/mo + ~$89/mo apps + 2.9% + $0.30/txn"
    },
    crystalcommerce: {
      label: "CrystalCommerce",
      commission: 0.025,      // 2.5% per channel
      processing: 0.029,      // 2.9% Stripe
      perTxn: 0.30,
      monthly: 99,            // $99/mo base
      description: "$99/mo + 2.5% per channel + 2.9% + $0.30/txn"
    }
  }

  connect() {
    this.calculate()
  }

  calculate() {
    const volume = parseInt(this.sliderTarget.value)
    const checked = this.platformTargets.find(r => r.checked)
    const platform = checked ? checked.value : "tcgplayer"
    const fee = this.constructor.fees[platform]

    // Estimate ~25 transactions per $5K volume (avg order ~$40 for TCG)
    const avgOrder = 40
    const txnCount = Math.ceil(volume / avgOrder)

    // Competitor cost
    const competitorCost = (volume * (fee.commission + fee.processing)) + (txnCount * fee.perTxn) + fee.monthly

    // SellCards: $29/mo flat + Stripe 2.9% + $0.30
    const sellcardsCost = 29 + (volume * 0.029) + (txnCount * 0.30)

    const monthlySavings = competitorCost - sellcardsCost
    const annualSavings = monthlySavings * 12

    this.volumeTarget.textContent = this.formatCurrency(volume)
    this.beforeTarget.textContent = this.formatCurrency(competitorCost) + "/mo"
    this.afterTarget.textContent = this.formatCurrency(sellcardsCost) + "/mo"
    this.platformLabelTarget.textContent = fee.label
    this.breakdownTarget.textContent = fee.description

    if (annualSavings > 0) {
      this.savingsTarget.textContent = this.formatCurrency(annualSavings) + "/year"
    } else {
      this.savingsTarget.textContent = this.formatCurrency(0) + "/year"
    }
  }

  formatCurrency(value) {
    return "$" + Math.round(value).toLocaleString()
  }
}
